import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import FeaturesService from 'ember-feature-flags/services/features';
import AnalyticsService from 'cio/services/analytics';
import EnvironmentService from 'cio/services/environment';
import ImportModel from 'cio/models/import';

export default class ImportsNew extends Controller {
  @service features!: FeaturesService;
  @service analytics!: AnalyticsService;
  @service environment!: EnvironmentService;

  declare model: ImportModel;

  queryParams = ['segmentId', 'type', 'objectTypeId'];

  readonly segmentId?: string;
  readonly type?: string;
  readonly objectTypeId?: string;

  @tracked previousRouteName: 'people' | 'imports' | 'segments.segment' | 'objects.type' = 'people';

  @action
  didClickCancel() {
    this.analytics.track('import', 'canceled', { model: this.model, source: 'imports.new' });
  }

  @action
  resetQueryParams() {
    this.setProperties({ segmentId: null, type: null, objectTypeId: null });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'imports/new': ImportsNew;
  }
}
